import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmRoomType {
    RoomType:   RQService.Pms.GetRoomTypesRow;

    IsSelected:  boolean;
    HasLiveData: boolean;

    constructor(
        pRoomType: RQService.Pms.GetRoomTypesRow
    ) {
        this.RoomType    = pRoomType;
        this.IsSelected  = false;
        this.HasLiveData = false;
    }
}

export class RoomTypesViewModel {
    ShowAlert:                     (pTitle: string, pMessage: string)                      => void;
    ShowConfirmation:              (pTitle: string ,pMessage: string ,pAction: () => void) => void;
    BackToSignIn:                  ()                                                      => void;
    NewLoading:                    (pMessage: string)                                      => dmLoading;

    mlText:                        MLText;
    app:                           mlBroker;
    ml:                            mlBroker;
    Hotel:                         dmHotel;
    LangID:                        number;
                            
    InAction:                      boolean;
                           
    SelectedLangID:                number;
    SelectedLangCode:              string;
    SelectedRoomTypeID:            number;
    SelectedNameInViewLang:        string;
    SelectedRoomTypeName:          string;
    SelectedNameStored:            string;
    SelectedRTPersonsNormal:       number;
    SelectedRTPersonsNormalStored: number;
    SelectedRTNumRooms:            number;
    SelectedRTNumRoomsStored:      number;
    SelectedRTHasLiveData:         boolean;

    HasSelectedRoomType:           boolean;
    WithFreeText:                  boolean;

    SelectedBaseID:                number;
    SelectedClassID:               number;
    SelectedPersonsNormal:         number;
    SelectedNumRooms:              number;
    AddHasFreeText:                boolean;
    AddNameEn:                     '';

    DeleteWarningInNativeLang:     string;
    
    RoomTypeBaseNames:             RQService.Pms.GetRoomTypeBaseNamesRow[];
    RoomTypeClassNames:            RQService.Pms.GetRoomTypeClassNamesRow[];
    RoomTypes:                     dmRoomType[];
    RoomTypesByID:                 dmRoomType[];
    Languages:                     RQService.Pms.GetLanguagesRow[];

    constructor(
         pMLText:           MLText
        ,pHotel:            dmHotel
        ,pBackToSignIn:     ()                                                        => void
        ,pShowAlert:        (pTitle:   string ,pMessage: string)                      => void
        ,pNewLoading:       (pMessage: string)                                        => dmLoading
        ,pShowConfirmation: (pTitle:   string ,pMessage: string ,pAction: () => void) => void
    ) {
        this.mlText                        = pMLText;
        this.LangID                        = this.mlText.GetLangID();
        this.app                           = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                            = this.mlText.GetBroker(
            'HotelAreaRoomTypes'
        );

        this.Hotel                         = pHotel;
        this.BackToSignIn                  = pBackToSignIn;
        this.ShowAlert                     = pShowAlert;
        this.ShowConfirmation              = pShowConfirmation;
        this.NewLoading                    = pNewLoading;
                                  
        this.InAction                      = true;
                                  
        this.SelectedLangID                = 1;
        this.SelectedLangCode              = 'en';
        this.SelectedRoomTypeID            = 0;
        this.SelectedNameInViewLang        = this.ml.Text(
             'NoRoomTypeSelectedWithBrackets'
            ,'(No room type selected)'
        );
        this.SelectedRoomTypeName          = '';
        this.SelectedNameStored            = '';

        this.SelectedRTPersonsNormal       = 0;
        this.SelectedRTPersonsNormalStored = 0;
        this.SelectedRTNumRooms            = 0;
        this.SelectedRTNumRoomsStored      = 0;

        this.HasSelectedRoomType           = false;
        this.WithFreeText                  = false;
        this.SelectedRTHasLiveData         = false;

        this.SelectedBaseID                = 1;
        this.SelectedClassID               = 1;
        this.SelectedPersonsNormal         = 1;
        this.SelectedNumRooms              = 1;
                                    
        this.AddHasFreeText                = false;
        this.AddNameEn                     = '';
                                    
        this.RoomTypeBaseNames             = [];
        this.RoomTypeClassNames            = [];
        this.RoomTypes                     = [];
        this.RoomTypesByID                 = [];
        this.Languages                     = [];

        let loading                        = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            let baseParams = RQParam.PmsGetRoomTypeBaseNamesParams();
            
            baseParams.LangID = this.LangID;
            
            RQService.Pms.GetRoomTypeBaseNames(baseParams).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) { loading.Dismiss(); return; }
            
                let baseNames = response.RQueryResult;
            
                for (let i = 0; i < baseNames.length; i++) {
                    let baseName = RQService.Pms.PopulateGetRoomTypeBaseNamesRow(
                        baseNames[i]
                    );
            
                    console.log('row push');
            
                    this.RoomTypeBaseNames.push(baseName);
                }
            
                let classParams = RQParam.PmsGetRoomTypeClassNamesParams();
            
                classParams.LangID = this.LangID;
            
                RQService.Pms.GetRoomTypeClassNames(classParams).then((result) => {
                    let response = result as any;
            
                    if (response.HasErrorOrException) { loading.Dismiss(); return; }
            
                    let classNames = response.RQueryResult;
            
                    for (let i = 0; i < classNames.length; i++) {
                        let className = RQService.Pms.PopulateGetRoomTypeClassNamesRow(
                            classNames[i]
                        );
            
                        console.log('row push');
            
                        this.RoomTypeClassNames.push(className);
                    }
            
                    RQService.Pms.GetLanguages(
                        {}
                    ).then((result) => {
                        let response = result as any;
            
                        if (response.HasErrorOrException) { loading.Dismiss(); return; }
            
                        let languages = response.RQueryResult;
            
                        for (let i = 0; i < languages.length; i++) {
                            let language = RQService.Pms.PopulateGetLanguagesRow(
                                languages[i]
                            );
            
                            console.log('row push');
            
                            this.Languages.push(language);
                        }

                        let nativeParams = RQParam.OtaGetRoomTypeDeletionWarningInHotelNativeLangParams();

                        nativeParams.HotelID = this.Hotel.HotelID;

                        RQService.Ota.GetRoomTypeDeletionWarningInHotelNativeLang(
                            nativeParams
                        ).then((result) => {
                            let response = result as any;

                            if (response.HasErrorOrException) { loading.Dismiss(); return; }

                            let warning = RQService.Ota.PopulateGetRoomTypeDeletionWarningInHotelNativeLangRow(
                                response.RQueryResult[0]
                            );

                            this.DeleteWarningInNativeLang = warning.DeletionWarningNative;

                            this.refreshRoomTypes(() => {
                                loading.Dismiss();
            
                                this.InAction = false;
                            });
                        });
                    });
                });
            });
        });
    }

    private refreshRoomTypes(pAction: () => void) {
        let roomTypesParams = RQParam.PmsGetRoomTypesParams();

        roomTypesParams.HotelID   = this.Hotel.HotelID;
        roomTypesParams.LangID    = this.LangID;

        this.RoomTypes.length     = 0;
        this.RoomTypesByID.length = 0;

        RQService.Pms.GetRoomTypes(roomTypesParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pAction(); return; }

            let roomTypes = response.RQueryResult;

            for (let i = 0; i < roomTypes.length; i++) {
                let roomType = new dmRoomType(
                    RQService.Pms.PopulateGetRoomTypesRow(
                        roomTypes[i]
                    )
                );

                console.log('row push');

                this.RoomTypes.push(roomType);

                this.RoomTypesByID[roomType.RoomType.RoomTypeID] = roomType;
            }

            let cacheDataStatusParams     = RQParam.PmsCheckRoomTypeCacheDataStatusParams();

            cacheDataStatusParams.HotelID = this.Hotel.HotelID;

            RQService.Pms.CheckRoomTypeCacheDataStatus(cacheDataStatusParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { pAction(); return; }

                let roomTypeStatuses = response.RQueryResult;

                for (let i = 0; i < roomTypeStatuses.length; i++) {
                    let roomTypeStatus = RQService.Pms.PopulateCheckRoomTypeCacheDataStatusRow(
                        roomTypeStatuses[i]
                    );

                    if (this.RoomTypesByID[roomTypeStatus.RoomTypeID]) {
                        this.RoomTypesByID[roomTypeStatus.RoomTypeID].HasLiveData
                            = (roomTypeStatus.HasCacheData == 1);
                    }
                }

                if (this.RoomTypesByID[this.SelectedRoomTypeID]) {
                    this.selectRoomTypeInternal(
                         this.SelectedRoomTypeID
                        ,() => { pAction(); }
                    );
                } else {
                    this.HasSelectedRoomType           = false;
                    this.WithFreeText                  = false;
                    this.SelectedRoomTypeID            = 0;
                    this.SelectedNameInViewLang        = this.ml.Text(
                         'NoRoomTypeSelectedWithBrackets'
                        ,'(No room type selected)'
                    );

                    this.SelectedRoomTypeName          = '';
                    this.SelectedNameStored            = '';

                    this.SelectedRTPersonsNormal       = 0;
                    this.SelectedRTPersonsNormalStored = 0;
                    this.SelectedRTNumRooms            = 0;
                    this.SelectedRTNumRoomsStored      = 0;

                    this.SelectedRTHasLiveData         = false;

                    pAction();
                }
            });
        });
    }

    private selectRoomTypeInternal(pRoomTypeID: number, pAction: () => void) {
        if (!this.RoomTypesByID[pRoomTypeID]) {
            this.HasSelectedRoomType = false;
            this.WithFreeText        = false;

            pAction();

            return;
        }

        this.SelectedRoomTypeID  = pRoomTypeID;

        let roomType: dmRoomType = this.RoomTypesByID[this.SelectedRoomTypeID];

        this.HasSelectedRoomType = true;

        if (roomType.RoomType.HasRoomTypeAutoName) { this.WithFreeText = false; }
        else                                       { this.WithFreeText = true;  }

        for (let i: number = 0; i < this.RoomTypes.length; i++) {
            if (roomType.RoomType.RoomTypeID == this.RoomTypes[i].RoomType.RoomTypeID) {
                this.RoomTypes[i].IsSelected = true;
            } else {
                this.RoomTypes[i].IsSelected = false;
            }
        }

        this.SelectedRTHasLiveData         = roomType.HasLiveData;

        this.SelectedRTPersonsNormal       = roomType.RoomType.PersonsNormal;
        this.SelectedRTPersonsNormalStored = roomType.RoomType.PersonsNormal;
        this.SelectedRTNumRooms            = roomType.RoomType.NrOfRooms;
        this.SelectedRTNumRoomsStored      = roomType.RoomType.NrOfRooms;

        this.SelectedNameInViewLang = roomType.RoomType.RoomTypeName;

        if (this.SelectedLangID == this.LangID) {
            this.SelectedRoomTypeName = roomType.RoomType.RoomTypeName;
            this.SelectedNameStored   = this.SelectedRoomTypeName;

            pAction();
        } else {
            let roomTypeParams = RQParam.PmsGetRoomTypeParams();

            roomTypeParams.HotelID    = this.Hotel.HotelID;
            roomTypeParams.RoomTypeID = roomType.RoomType.RoomTypeID;
            roomTypeParams.LangID     = this.SelectedLangID;

            RQService.Pms.GetRoomType(roomTypeParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { return; }

                let roomTypeML = RQService.Pms.PopulateGetRoomTypeRow(
                    response.RQueryResult[0]
                )

                this.SelectedRoomTypeName = roomTypeML.RoomTypeName;
                this.SelectedNameStored   = this.SelectedRoomTypeName;

                pAction();
            });
        }
    }

    public SelectLanguage(pLangID: number) {
        if (this.InAction) { return; }

        this.SelectedLangID   = pLangID;
        this.SelectedLangCode = this.Languages[(pLangID - 1)].LangISOCode;

        if (this.SelectedRoomTypeID != 0) {
            this.InAction = true;

            let loading   = this.NewLoading(
                this.app.Text('LoadingMark', 'Loading...')
            );

            loading.Show(() => {
                this.selectRoomTypeInternal(
                     this.SelectedRoomTypeID
                    ,() => {
                        loading.Dismiss();
                
                        this.InAction = false;
                    }
                );
            });
        }
    }

    public SelectRoomType(pRoomTypeID: number) {
        if (this.InAction) { return; }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.selectRoomTypeInternal(
                 pRoomTypeID
                ,() => {
                    loading.Dismiss();
            
                    this.InAction = false;
                }
            );
        });
    }

    public SelectRoomTypeBase(pRoomTypeBaseID: number) {
        this.SelectedBaseID = pRoomTypeBaseID;

        for (let i: number = 0; i < this.RoomTypeBaseNames.length; i++) {
            let base = this.RoomTypeBaseNames[i];

            if (base.RoomBaseID == this.SelectedBaseID) {
                this.SelectedPersonsNormal = base.DefaultPersonsNormal;
            }
        }
    }

    public SelectRoomTypeClass(pRoomTypeClassID: number) {
        this.SelectedClassID = pRoomTypeClassID;
    }

    public AddRoomType() {
        if (this.InAction) { return; }

        if (this.AddHasFreeText && this.AddNameEn == '') {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddRoomType'
                    ,'Cannot Add Room Type'
                )
                ,this.ml.Text(
                     'RoomTypeNameEmpty'
                    ,'Room type name cannot be empty'
                )
            );

            return;
        }

        this.SelectedPersonsNormal = Math.floor(this.SelectedPersonsNormal);
        this.SelectedNumRooms      = Math.floor(this.SelectedNumRooms);

        if (this.SelectedNumRooms < 1) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddRoomType'
                    ,'Cannot Add Room Type'
                )
                ,this.ml.Text(
                     'NumRoomsMust'
                    ,'Number of rooms must be a whole number greater than 0'
                )
            );

            return;
        }

        if (this.SelectedPersonsNormal < 1) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddRoomType'
                    ,'Cannot Add Room Type'
                )
                ,this.ml.Text(
                     'PersonsNormalMust'
                    ,'Persons normal must be a whole number greater than 0'
                )
            );

            return;
        }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let addParams = RQParam.PmsNewRoomTypeWithAutoNameParams();
            
            addParams.HotelID          = this.Hotel.HotelID;
            addParams.RoomBaseID       = (this.AddHasFreeText) ? 0 : this.SelectedBaseID;
            addParams.RoomClassID      = (this.AddHasFreeText) ? 0 : this.SelectedClassID;
            addParams.NrOfRooms        = this.SelectedNumRooms;
            addParams.PersonsNormal    = this.SelectedPersonsNormal;
            addParams.MaxPersonsNormal = this.SelectedPersonsNormal;
            addParams.MinPrice         = 0;
            addParams.MaxPrice         = 0;
            addParams.FreeText         = (this.AddHasFreeText) ? this.AddNameEn : '';
            addParams.LangID           = this.LangID;
            
            RQService.Pms.NewRoomTypeWithAutoName(addParams).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) {
                    loading.Dismiss();
            
                    this.InAction = false;
            
                    return;
                }
            
                this.SelectedBaseID        = 1;
                this.SelectedClassID       = 1;
                this.SelectedPersonsNormal = 1;
                this.SelectedNumRooms      = 1;
            
                this.AddHasFreeText        = false;
                this.AddNameEn             = '';
            
                this.refreshRoomTypes(() => {
                    this.selectRoomTypeInternal(
                         this.RoomTypes[(this.RoomTypes.length - 1)].RoomType.RoomTypeID
                        ,() => {
                            loading.Dismiss();
            
                            this.InAction = false;
                        }
                    );
                });
            });
        });
    }

    private deleteRoomTypeInternal(pRoomTypeID: number): void {
        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let roomType: dmRoomType = this.RoomTypesByID[pRoomTypeID];
            
            let deleteParams = RQParam.PmsDeleteRoomTypeParams();
            
            deleteParams.HotelID    = this.Hotel.HotelID;
            deleteParams.RoomTypeID = roomType.RoomType.RoomTypeID;
            deleteParams.LangID     = this.LangID;
            
            RQService.Pms.DeleteRoomType(deleteParams).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.refreshRoomTypes(() => {
                    loading.Dismiss();
            
                    this.InAction = false;
                });
            });
        });
    }

    public DeleteRoomType(pRoomTypeID: number): void {
        if (this.InAction) { return; }

        if (!this.RoomTypesByID[pRoomTypeID]) {
            this.HasSelectedRoomType   = false;
            this.WithFreeText          = false;
            this.SelectedRTHasLiveData = false;

            return;
        }

        if (this.RoomTypesByID[pRoomTypeID].HasLiveData) {
            let warning: string = '';

            if (this.DeleteWarningInNativeLang.length > 0) {
                warning += this.DeleteWarningInNativeLang;
                warning += '\r\n\r\n----------\r\n\r\n';
            }

            warning += this.ml.Text(
                 'WarningDelete'
                ,'Please contact your CHANNEL-MANAGER when trying to remove an existing '
                  + 'ROOMTYPE. Delete This Room Type?'
            );

            this.ShowConfirmation(
                 this.ml.Text(
                     'WarningTitle'
                    ,'Please contact your CHANNEL-MANAGER'
                )
                ,warning
                ,() => {
                    this.deleteRoomTypeInternal(pRoomTypeID);
                }
            );
        } else {
            this.deleteRoomTypeInternal(pRoomTypeID);
        }
    }

    private editRoomTypeDetailsInternal(pRoomType: dmRoomType): void {
        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let roomTypeName: string = '';

            if (pRoomType.RoomType.HasRoomTypeAutoName == 0) {
                roomTypeName = this.SelectedRoomTypeName;
            }

            let editDetailsParams = RQParam.PmsEditRoomTypeNameAndParamsParams();

            editDetailsParams.HotelID          = this.Hotel.HotelID;
            editDetailsParams.RoomTypeID       = pRoomType.RoomType.RoomTypeID;
            editDetailsParams.PersonsNormal    = this.SelectedRTPersonsNormal;
            editDetailsParams.MaxPersonsNormal = this.SelectedRTPersonsNormal;
            editDetailsParams.RoomTypeName     = roomTypeName;
            editDetailsParams.NumRooms         = this.SelectedRTNumRooms;
            editDetailsParams.LangID           = this.SelectedLangID;
           
            RQService.Pms.EditRoomTypeNameAndParams(editDetailsParams).then((result) => {
                let response = result as any;
           
                if (response.HasErrorOrException) {
                    this.SelectedRoomTypeName          = this.SelectedNameStored;
                    this.SelectedRTPersonsNormal       = this.SelectedRTPersonsNormalStored;
                    this.SelectedRTNumRooms            = this.SelectedRTNumRoomsStored;
                } else {
                    this.SelectedNameStored            = this.SelectedRoomTypeName;
                    this.SelectedRTPersonsNormalStored = this.SelectedRTPersonsNormal;
                    this.SelectedRTNumRoomsStored      = this.SelectedRTNumRooms;
                }
           
                if (this.SelectedLangID == this.LangID) {
                    this.refreshRoomTypes(() => {
                        loading.Dismiss();
           
                        this.InAction = false;
                    });
                } else {
                    loading.Dismiss();
           
                    this.InAction = false;
                }
            });
        });
    }

    public EditRoomTypeDetails(): void {
        if (this.InAction) { return; }

        if (!this.RoomTypesByID[this.SelectedRoomTypeID]) {
            this.HasSelectedRoomType   = false;
            this.WithFreeText          = false;
            this.SelectedRTHasLiveData = false;

            return;
        }

        let roomType: dmRoomType = this.RoomTypesByID[this.SelectedRoomTypeID];

        if ((roomType.RoomType.HasRoomTypeAutoName == 0) && (this.SelectedRoomTypeName == '')) {
            this.ShowAlert(
                 this.ml.Text('CantEditRoomTypeDetails' ,'Cannot Edit Room Type Details')
                ,this.ml.Text('RoomTypeNameEmpty'       ,'Room type name cannot be empty')
            );

            return;
        }

        if (this.SelectedRTPersonsNormal < 1) {
            this.ShowAlert(
                 this.ml.Text('CantEditRoomTypeDetails' ,'Cannot Edit Room Type Details')
                ,this.ml.Text('PNormalZero'             ,'Persons Normal must be at least one')
            );

            return;
        }

        if (this.SelectedRTNumRooms < 1) {
            this.ShowAlert(
                 this.ml.Text('CantEditRoomTypeDetails' ,'Cannot Edit Room Type Details')
                ,this.ml.Text('NRoomsZero'              ,'Number of Rooms must be at least one')
            );

            return;
        }

        if        (this.SelectedRTNumRooms > roomType.RoomType.NrOfRooms) {
            this.ShowConfirmation(
                 this.ml.Text(
                     'WarningTitle'
                    ,'WARNING: Room Type has Live Data'
                )
                ,this.ml.Text(
                     'WarningAddRooms'
                    ,'WARNING: Room Type has Live Data! If you are sure you want to add '
                      + 'rooms to it, contact any channel provider to resync availability '
                      + 'data ASAP. (New rooms will be open by default). Add rooms to this '
                      + 'room type?'
                )
                ,() => {
                    this.editRoomTypeDetailsInternal(roomType);
                }
            );
        } else if (this.SelectedRTNumRooms < roomType.RoomType.NrOfRooms) {
            this.ShowConfirmation(
                 this.ml.Text(
                     'WarningTitle'
                    ,'WARNING: Room Type has Live Data'
                )
                ,this.ml.Text(
                     'WarningRemoveRooms'
                    ,'WARNING: Room Type has Live Data! If you are sure you want to remove '
                      + 'rooms from it, contact any channel provider to resync availability '
                      + 'data ASAP. Remove rooms from this room type?'
                )
                ,() => {
                    this.editRoomTypeDetailsInternal(roomType);
                }
            );
        } else {
            this.editRoomTypeDetailsInternal(roomType);
        }
    }

    public NudgeRoomType(pRoomTypeID: number ,pUp: boolean) {
        if (this.InAction) { return; }

        if (!this.RoomTypesByID[pRoomTypeID]) { return; }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let roomType: dmRoomType   = this.RoomTypesByID[pRoomTypeID];
            let nudgeParams            = RQParam.PmsShuffleRoomTypeOrderParams();
            
            nudgeParams.HotelID        = this.Hotel.HotelID;
            nudgeParams.SortOrderBegin = roomType.RoomType.SortOrder;
            nudgeParams.SortOrderEnd   = roomType.RoomType.SortOrder;
            nudgeParams.Up             = (pUp) ? 1 : 0;
            nudgeParams.LangID         = this.LangID;
            
            RQService.Pms.ShuffleRoomTypeOrder(nudgeParams).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) {
                    loading.Dismiss();
            
                    this.InAction = false;
            
                    return;
                }
            
                this.refreshRoomTypes(() => {
                    loading.Dismiss();
            
                    this.InAction = false;
                });
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/roomtypes/xv-roomtypes.ts